// 课程类型
export const COURSE_TYPE = {
  // 首页
  FIRST_PAGE: 11,
  // 全部
  ALL: 10,
  // 公开课
  OPEN: 1,
  // 收费班课
  PRICED: 3,
  // 系列课
  SERIES: 4,
  // 专题课
  SPECIAL: 5,
  // 体验课
  EXPERIENCE: 6,
  // 首页展示的公开课
  FIRST_PAGE_OPEN: 12,
  // 公开课+体验课
  OPEN_EXPERIENCE: 21,
  // 系列课+专题课
  NEO_PRICED: 22,
  // 联报优惠
  CLAZZ_SET: 23
};

// 公开课对应的courseType
export const OPENCLASS_COURSETYPE = {
  // 公开课
  OPEN: 1,
  // 体验课
  EXPERIENCE: 6,
  // 小班课公开课
  SMALL_OPEN: 31,
  // 小班课体验课
  SMALL_EXPERIENCE: 36,
};

// 小班课对应的课程类型
export const SMALL_CLASS_COURSETYPE = {
  // 公开课
  SMALL_OPEN: 31,
  // 收费班课
  SMALL_PRICED: 32,
  // 系列课
  SMALL_SERIES: 34,
  // 专题课
  SMALL_SPECIAL: 35,
  // 体验课
  SMALL_EXPERIENCE: 36,
};

// 视频课程筛选选项
export const FILTER_TYPE = {
  1: '状态',
  2: '科目',
};

// 视频课程筛选状态选项
export const FILTER_STATUS = [
  {
      clazzStatus: 0,
      name: '全部',
  },
  {
      clazzStatus: 1,
      name: '未完结',
  },
  {
      clazzStatus: 2,
      name: '已完结',
  },
];

// 0 未开始 1 即将直播 2 正在直播 3 已结束回放未生成 4 回放已经生成
export const LIVE_STATUS_NOT_START = 0;
export const LIVE_STATUS_COMING = 1;
export const LIVE_STATUS_PLAYING = 2;
export const LIVE_STATUS_HAS_NOT_PLAYBACK = 3;
export const LIVE_STATUS_HAS_PLAY_BACK = 4;

export const LIVE_STATUS_DESCRIBE = {
  [LIVE_STATUS_NOT_START]: '未开始',
  [LIVE_STATUS_COMING]: '即将直播',
  [LIVE_STATUS_PLAYING]: '正在直播',
  [LIVE_STATUS_HAS_NOT_PLAYBACK]: '已结束回放未生成',
  [LIVE_STATUS_HAS_PLAY_BACK]: '回放已经生成',
};
